import {$getModuleColor, $getModuleIcon} from "./appModules"
import {useAuthStore} from "~/store/auth"
import type {SidebarMenu} from "~/types/sidebarMenu"

export const sidebarMenu: SidebarMenu = [
    {
        title: 'default',
        menu: [
            {
                title: 'menu.dashboard',
                path: 'service-dashboard',
                icon: $getModuleIcon('dashboard'),
                module: 'dashboard',
            },
            {
                title: 'menu.myOrganisation',
                path: {
                    name: 'service-organisations-id-organisationBaseData',
                    params: {id: (useAuthStore().userData?.organisation_id ?? '') as string}
                },
                module: 'organisations',
                icon: $getModuleIcon('organisations'),
                ability: ['view', 'organisations']
            },
            {
                title: 'menu.organisations',
                path: {name: 'service-organisations'},
                module: 'organisations',
                icon: $getModuleIcon('organisations'),
                ability: ['db.viewAll', 'organisations']
            },
            {
                title: 'menu.organisations',
                path: {name: 'service-organisations'},
                module: 'organisations',
                icon: $getModuleIcon('organisations'),
                ability: ['db.viewSameSport', 'organisations']
            },
            {
                title: 'menu.contactPersons',
                path: {name: 'service-contactPersons'},
                module: 'contactPersons',
                icon: $getModuleIcon('contactPersons'),
                ability: ['viewAny', 'personLinks']
            },
            {
                title: 'menu.users',
                path: {name: 'service-users'},
                module: 'users',
                icon: $getModuleIcon('users'),
                ability: ['viewAny', 'users']
            },
            {
                title: 'menu.sportsManagement',
                path: 'service-sportsManagement',
                icon: $getModuleIcon('sportsManagement'),
                color: $getModuleColor('sportsManagement'),
                module: 'sportsManagement',
                ability: ['view', 'sportsManagement'],
                children: [
                    {
                        title: 'menu.gameClasses',
                        path: 'service-sportsManagement-gameClasses',
                        ability: ['viewAny', 'gameClasses']
                    }, {
                        title: 'menu.contests',
                        path: 'service-sportsManagement-contests',
                        ability: ['viewAny', 'contests']
                    }, {
                        title: 'menu.gameDays',
                        path: 'service-sportsManagement-gameDays',
                        ability: ['viewAny', 'gameDays']
                    }, {
                        title: 'menu.tournamentSeries',
                        path: 'service-sportsManagement-tournamentSeries',
                        ability: ['viewAny', 'tournaments']
                    }, {
                        title: 'menu.refereeSchedule',
                        path: 'service-sportsManagement-refereeSchedule',
                        ability: ['viewAny', 'refereeSchedule']
                    }, {
                        title: 'menu.venueDateRegistrations',
                        path: 'service-sportsManagement-venueDateRegistrations',
                        ability: ['viewAny', 'venueDateRegistrations']
                    }, {
                        title: 'menu.invoices',
                        path: 'service-sportsManagement-invoices',
                        ability: ['viewAny', 'invoices']
                    }, {
                        title: 'menu.gamePlanner',
                        path: 'service-sportsManagement-gamePlanner',
                        ability: ['viewAny', 'gamePlanner']
                    }
                ]
            },
            {
                title: 'menu.basicData',
                path: 'service-basicData',
                icon: $getModuleIcon('basicData'),
                color: $getModuleColor('basicData'),
                module: 'basicData',
                ability: ['view', 'basicData'],
                children: [
                    {
                        title: 'menu.seasons',
                        path: 'service-basicData-seasons',
                        ability: ['viewAny', 'seasons']
                    }, {
                        title: 'menu.sports',
                        path: 'service-basicData-sports',
                        ability: ['viewAny', 'sports']
                    }, {
                        title: 'menu.venues',
                        path: 'service-basicData-venues',
                        ability: ['viewAny', 'venues']
                    }, {
                        title: 'menu.penaltyTypes',
                        path: 'service-basicData-penaltyTypes',
                        ability: ['viewAny', 'penaltyTypes']
                    }, {
                        title: 'menu.mailTemplates',
                        path: 'service-basicData-mailTemplates',
                        ability: ['viewAny', 'mailTemplates']
                    }, {
                        title: 'menu.mails',
                        path: 'service-basicData-mails',
                        ability: ['viewAny', 'mails']
                    }
                ]
            },
            {
                title: 'menu.website',
                path: 'admin',
                icon: $getModuleIcon('website'),
                color: $getModuleColor('website'),
                module: 'website',
                ability: ['update', 'website'],
            }
        ]
    }
]